import { ProductContractType } from "@/modules/Offers/types/ProductsOffers.types";

export const CONTRACT_TYPES = [
  { key: ProductContractType.NEW, text: ProductContractType.NEW },
  { key: ProductContractType.EXISTENT, text: ProductContractType.EXISTENT }
];
